export default "__VITE_ASSET__C2nbI2ni__"